module.exports = __webpack_public_path__ + "js/1.0069f3f8.worker.js"